import _ from '../../utils/LodashImports';

const waitForDigitalDataSiS = () => {
  return new Promise((resolve) => {
    const checkExist = setInterval(() => {
      const xlpSiS = _.get(window, 'digitalData.tag.XLP.sis_experience', undefined);
      if (xlpSiS) {
        clearInterval(checkExist);
        resolve();
      }
    }, 300);
  });
};

const getTargetValues = (appCtx, productGcategory) => {
  const safeCategory = typeof productGcategory === 'string' ? productGcategory : '';
  const baseData = {
    store_in_store: _.get(appCtx, 'store', 'falabella') || 'falabella',
    emailHash: _.get(window, 'digitalData.login.emailHash', undefined),
    gcategory_a: safeCategory ? safeCategory.slice(0, 3) : undefined,
    gcategory_b: safeCategory ? safeCategory.slice(0, 5) : undefined,
    gcategory_c: safeCategory ? safeCategory.slice(0, 7) : undefined,
    gcategory_d: safeCategory ? safeCategory.slice(0, 9) : undefined,
  };
  const filteredDigitalDataObject = Object.fromEntries(Object.entries(baseData).filter(([, value]) => !!value));
  return filteredDigitalDataObject;
};

export { getTargetValues, waitForDigitalDataSiS };
